export type DocumentMetadataDto = {
  originalName: string;
  size: number | null;
  uploadedAt: string;
  pinned: boolean;
  lastSharedAt: string | null;
};

export type DocumentWithMetadataDto = {
  fileName: string;
  path: string;
  metadata?: DocumentMetadataDto;
  size?: number; // ⬅️ Populated from BlobItem.Properties.ContentLength
  folderId?: string | null;
};

export enum FolderAccessLevel {
  NoAccess = 0,
  Read = 1,
  Write = 2,
  Full = 3,
}

export interface FolderMemberPermissionDto {
  clinicUserId: string;
  userName: string;
  email: string;
  accessLevel: FolderAccessLevel | null;

  via3UserType: 'Admin' | 'Staff' | 'Member';
  isCurrentUser: boolean;
}

export interface FolderMemberPermissionUpdateDto {
  clinicUserId: string;
  accessLevel: FolderAccessLevel;
}

export interface GetFolderPermissionsResponse {
  folderPath: string;
  members: FolderMemberPermissionDto[];
}

export interface UpdateFolderPermissionsRequest {
  folderId: string;
  permissions: FolderMemberPermissionUpdateDto[];
}
